//@ts-nocheck
import { createGetRequest, createPostRequest } from 'lp-redux-api';
import { makeQueryPath } from 'shared';
export const getCreditApplicationsByStatus = createGetRequest('GET_CREDIT_APPLICATIONS_BY_STATUS', (applicationSearchCriteria, status) => ({
    url: `/consumer_applications/v1/credit_applications/status/${status}`,
    query: applicationSearchCriteria,
}));
export const validateSSN = createPostRequest('VALIDATE_SSN', (resourceId, resourceType, validationType, validationInput) => ({
    url: '/consumer/v2/auth/validate',
    body: {
        resourceId,
        resourceType,
        validationType,
        validationInput,
    },
}));
export const applyAfterPrequalification = createPostRequest('APPLY_AFTER_PREQUALIFICATION', (application) => ({
    url: '/consumer_applications/v1/credit_applications/apply_after_prequalification',
    body: application,
}));
export const searchForPractices = createGetRequest('PRACTICE_DATA', (identifier, type = 'store', language = 'en') => ({
    url: `/consumer_applications/v1/locations/search`,
    query: {
        ...(type === 'location'
            ? { location_id: identifier }
            : { ads_store_number: identifier }),
        language,
    },
}));
export const createCreditApplicationIdentityVerification = createPostRequest('CREATE_CREDIT_APPLICATION_IDENTITY_VERIFICATION', (creditApplicationId, creditApplicationData) => ({
    url: `/consumer_applications/v1/credit_applications/${creditApplicationId}/identity_verification`,
    body: creditApplicationData,
}));
export const getCreditApplicationIdentityVerification = createGetRequest('GET_CREDIT_APPLICATION_IDENTITY_VERIFICATION', (creditApplicationId) => ({
    url: `/consumer_applications/v1/credit_applications/${creditApplicationId}/identity_verification`,
}));
export const submitFullApplication = createPostRequest('POST_FULL_APPLICATION', (creditApplicationId, creditApplicationData) => ({
    url: `/consumer_applications/v1/credit_applications/${creditApplicationId}/apply`,
    body: creditApplicationData,
}));
export const getLenderTerms = createGetRequest('GET_LENDER_TERMS', (locationId, lenderName) => ({
    url: makeQueryPath(`/consumer_applications/v1/locations/${locationId}/lender_terms/${lenderName}`),
}));
export const getPracticeLocations = createGetRequest('GET_LOCATIONS', (fields_to_search, search_criteria, limit = 5) => ({
    url: '/consumer_applications/v1/locations/search_full',
    query: {
        search_criteria: search_criteria,
        fields_to_search: fields_to_search,
        limit: limit,
    },
}));
